<template>
  <div class="detail-comment-send">
    <!-- 文本输入 -->
    <div
      ref="textBox"
      class="comment-input"
      contenteditable="true"
      :placeholder="placeholder"
      :style="customStyle"
      @input="handleInput"
      @focus="handleFocus"
      @blur="onBlur"
      @paste="handlePaste"
      @keypress.ctrl.exact.prevent="onCtrlEnter"
      @keypress.enter.exact.prevent="onEnter"
    ></div>
    <!-- 工具栏 -->
    <div v-if="showToolBar" class="tool-bar">
      <div class="left-wrapper">
        <!-- 图片上传 -->
        <div v-if="showImg" class="img-update-btn">
          <i class="wiki-icon wiki-editor-pic"></i><input accept="image/*" type="file" @change="uploadImg" />
        </div>
        <!-- 表情包 -->
        <div ref="emojiTippyRef" class="emoji-update-btn" @click="handleOpenEmojiPanel"></div>
      </div>
      <!-- 确认按钮 -->
      <div style="display: flex;">
        <el-button class="send-btn" type="primary" @click="_onOk">{{ sendBtnText }}</el-button>
        <el-button class="cancel-btn" @click="() => $emit('cancel')">取消</el-button>
      </div>
    </div>
    <!-- 图片、视频 -->
    <div v-if="resources.length" class="img-group">
      <div v-for="(item, index) in resources" :key="item.key" class="item">
        <div class="close-btn" @click="onCloseImg(index)">
          <i class="el-icon-close"></i>
        </div>
        <div v-if="item.percent > 0 && item.percent < 100" class="percent-box">{{ item.percent }}%</div>
        <img v-if="item.url" :src="item.url" alt="" />
        <img v-else src="@/assets/images/local.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { uploadFile } from "@/plugins/uploadFile";
import { openEmojiPanel } from "@/views/wiki/components/emoji";

export default {
  props: {
    // 编辑框占位文案
    placeholder: {
      type: String,
      default: "说点什么吧"
    },
    customStyle: {
      type: Object,
      default: () => ({})
    },
    // 确认按钮文案
    sendBtnText: {
      type: String,
      default: "发 布"
    },
    // 是否显示上传视频按钮
    showVideo: {
      type: Boolean,
      default: true
    },
    // 是否显示上传视频按钮
    showImg: {
      type: Boolean,
      default: true
    },
    isShowEdit: {
      type: Boolean,
      default: true
    },
    // 确定按钮回调
    onOk: {
      type: Function,
      default: null
    },
    showToolBar: {
      type: Boolean,
      default: false
    }
  },
  model: {},
  components: {},
  data() {
    return {
      savedRange: null,
      resources: [],
    };
  },
  computed: {
    ...mapGetters(["gameInfo", "loginUser"])
  },
  methods: {
    uploadImg(e) {
      let file = e.target.files[0];
      console.log('上传图片',file);
      let item = {
        file: file,
        percent: 0,
        type: "img",
        url: "",
        key: parseInt(Math.random() * 1000000)
      };
      this.resources.push(item);
      uploadFile({
        file,
        percent: 0,
        progressCb: percent => {
          item.percent = percent;
        }
      }).then(res => {
        item.percent = 100;
        item.url = res.url;
      });
    },
    onCloseImg(index) {
      this.resources.splice(index, 1);
    },

    _onOk() {
      let isUpdate = true;
      this.resources.forEach(item => {
        if (item.percent < 100) {
          isUpdate = false;
        }
      });
      if (!isUpdate) {
        this.$message("还有资源未上传完成");
        return;
      }
      const text = this.$refs.textBox.innerHTML || "";
      if (text.trim() == "" && this.resources.length == 0) {
        this.$message("内容为空，请重新输入！");
        return;
      }
      const data = this.formatData();
      if (this.onOk) {
        this.onOk(data);
      }
    },
    onClear() {
      this.$refs.textBox.innerHTML = "";
      this.resources = [];
    },
    onEnter() {
      this._onOk();
    },
    onCtrlEnter(event) {
      if (event.code === "Enter") {
        document.execCommand("insertText", false, "\n");
      }
    },
    handleInput() {
      const text = this.$refs.textBox.innerHTML;
      if (text.length === 1 && !text.trim()) {
        this.$refs.textBox.innerHTML = "";
      }
    },
    handleFocus() {
      const savedRange = this.savedRange;
      if (savedRange) {
        const selection = window.getSelection();
        selection.removeAllRanges(); // 清除当前选择
        selection.addRange(savedRange); // 恢复光标
      }
      this.$emit("focus");
    },
    // 在光标位置插入文本
    insertTextAtCursor(text) {
      const selection = window.getSelection();
      if (selection.rangeCount > 0) {
        const range = selection.getRangeAt(0);
        range.deleteContents();
        const textNode = document.createTextNode(text);
        range.insertNode(textNode);

        // 移动光标到插入文本之后
        range.setStartAfter(textNode);
        range.collapse(true);
        selection.removeAllRanges();
        selection.addRange(range);
      } else {
        // 如果没有选中区域，直接追加到内容末尾
        this.$refs.textBox.innerHTML += text;
      }
    },
    handlePaste(e) {
      e.preventDefault();
      const clipboardData = e.clipboardData || window.clipboardData;

      // 处理文本
      const pastedText = clipboardData.getData('text/plain');
      if (pastedText) {
        this.insertTextAtCursor(pastedText);
      }

      // 处理图片
      const items = clipboardData.items;
      for (let i = 0; i < items.length; i++) {
        console.log(items[i]);
        if (items[i].type.indexOf('image') !== -1) {
          const blob = items[i].getAsFile()
          console.log('上传信息', blob);

          const url = URL.createObjectURL(blob)
          const item = {
            file: blob,
            percent: 0,
            type: 'img',
            url,
            key: parseInt(Math.random() * 1000000)
          }
          this.resources.push(item);
          // 上传图片（如果有上传逻辑）
          uploadFile({
            file: blob,
            percent: 0,
            progressCb: percent => {
              item.percent = percent;
            }
          }).then(res => {
            item.percent = 100;
            item.url = res.url; // 替换为服务器返回的URL
          });

          break;
        }
      }
    },
    onBlur() {
      const selection = window.getSelection();
      if (selection.rangeCount > 0) {
        const savedRange = selection.getRangeAt(0); // 存储 Range
        this.savedRange = savedRange;
      }
    },
    async handleOpenEmojiPanel() {
      this.$refs.textBox.focus();
      const emoji = await openEmojiPanel(this.$refs.emojiTippyRef)
        .then(value => value)
        .catch(() => null);
      if (!emoji) return;

      let sel, range;
      if (window.getSelection && (sel = window.getSelection()).rangeCount) {
        range = sel.getRangeAt(0);
        range.collapse(true);
        const img = document.createElement("img");
        img.style.width = "20px";
        img.style.height = "20px";
        img.style.margin = "0 2px";
        img.src = emoji.icon;
        img.dataset.emoji = emoji.name;
        img.alt = emoji.name;
        range.insertNode(img);

        range.setStartAfter(img);
        range.collapse(true);
        sel.removeAllRanges();
        sel.addRange(range);
      }
    },
    formatData() {
      const html = this.$refs.textBox.innerHTML || "";
      const text = html.replace(/<img[^>]*alt="([^"]*)"[^>]*>/g, "$1");
      let contentJson = [{ type: "paragraph", children: [{ text: text }] }];
      let thumb = [];
      this.resources.forEach(item => {
        if (item.type == "img") {
          // 一行一个
          const imgJson = {
            type: "paragraph",
            children: [
              { text: "" },
              {
                type: "image",
                key: Math.random()
                  .toString(8)
                  .slice(2),
                src: item.url,
                alt: "",
                isAdaptive: true,
                style: {},
                children: [{ text: "" }]
              },
              { text: "" }
            ]
          };
          contentJson.push(imgJson);
          if (thumb.length < 3) {
            thumb.push(item.url);
          }
        } else if (item.type == "video") {
          const videoJson = {
            type: "video",
            src: item.videoUrl,
            poster: item.url,
            children: [{ text: "" }]
          };
          contentJson.push(videoJson);
        }
      });

      return {
        text,
        resources: this.resources,
        contentJson,
        thumb
      };
    }
  }
};
</script>

<style lang="less" scoped>
.detail-comment-send {
  width: 100%;
  background: #f5f5f5;
  border-radius: 4px;
}
.comment-input {
  max-height: 100px;
  font-size: 14px;
  padding: 14px 10px;
  user-modify: read-write-plaintext-only;
  -webkit-user-modify: read-write-plaintext-only;
  overflow: auto;
  resize: none;
  border: none;

  &:empty:before {
    content: attr(placeholder);
    color: #999;
    font-size: 13px;
  }
}

.tool-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 10px;
  .left-wrapper {
    display: flex;
    align-items: center;

    .img-update-btn {
      height: 30px;
      position: relative;
      line-height: 30px;
      text-align: center;
      background-size: 100% 100%;
      border-radius: 4px;
      font-size: 24px;
      cursor: pointer;
      input {
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 10;
        top: 0;
        left: 0;
        opacity: 0;
      }
    }
    .emoji-update-btn {
      width: 20px;
      height: 20px;
      position: relative;
      bottom: 1px;
      background: url("~@/assets/images/comment-emoji-btn.png") no-repeat;
      background-size: 20px 20px;
      margin-left: 6px;
      cursor: pointer;
    }
  }
  .send-btn,
  .cancel-btn {
    width: 52px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    background: #00afe8;
    border-radius: 4px;
  }
  .cancel-btn {
    color: #6f6f6f;
    background-color: #fff;
  }
}

.img-group {
  display: flex;
  flex-wrap: wrap;
  padding: 10px;

  .item {
    width: 60px;
    height: 60px;
    margin: 10px 10px 0 0;
    position: relative;

    img {
      width: 100%;
      height: 100%;
    }

    .close-btn {
      position: absolute;
      top: -6px;
      right: -6px;
      z-index: 10;
      background: #fff;
      border-radius: 50%;
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 0 3px #ddd;
      cursor: pointer;
      transition: 0.3s;

      &:hover {
        box-shadow: 0 0 6px #bbb;
      }
    }

    .percent-box {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 9;
      display: flex;
      align-items: center;
      justify-content: center;
      background: fade(#000, 20%);
      width: 100%;
      height: 100%;
      color: #333;
      font-size: 12px;
    }

    .el-icon-video-play {
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: 5;
      transform: translate(-50%, -50%);
      font-size: 30px;
      color: #fff;
      text-shadow: 0 0 4px #bbb;
    }
  }
}
</style>
